export default __webpack_public_path__ + "static/media/map3.c0c24f15.png";